<template>
  <div id="tac-admin-sales-refund" class="tac-admin sales-refund">
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
  </div><!-- #tac-admin-sales-refund -->
</template>

<script>
import ApiResponseMixin from '@/plugin/mixin/api-response'
import AuthMixin from '@/plugin/mixin/auth'
import FormMixin from '@/plugin/mixin/form'

export default {
  mixins: [
    ApiResponseMixin,
    AuthMixin,
    FormMixin
  ]
}
</script>
